import { useState } from "react";
import "./css/NavMenu.css";
import {
  Menu,
  ArrowLeft,
  DatabaseSearch,
  ShieldUser,
  LogOut
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

export default function NavMenu({ isadmin, setPage }) {

  const [open, setOpen] = useState(false);
   const navigate = useNavigate();

  return (
    <>
      <button className="settings-toggle" onClick={() => setOpen(!open)}>
        <Menu size={20} />
      </button>

      <aside className={`settings-panel ${open ? "open" : ""}`}>

        <div className="settings-top">
          <Link className="home-btn" to="/">
            <ArrowLeft size={18} />
            Home
          </Link>
        </div>

        <nav className="settings-nav">

          <button type="button" onClick={() => setPage("user")}>
            <DatabaseSearch size={18} />
            Nutzerdaten
          </button>

          {isadmin && (
            <button type="button" onClick={() => setPage("admin")}>
              <ShieldUser size={18} />
              Adminbereich
            </button>
          )}

        </nav>

        <div className="logout-section">
          <button className="logout-btn" onClick={() => navigate("/logout")}>
            <LogOut size={18} />
            Abmelden
          </button>
        </div>

      </aside>

      {open && (
        <div className="settings-overlay" onClick={() => setOpen(false)} />
      )}
    </>
  );
}
